import { addEdge, applyEdgeChanges, type EdgeAddChange, type EdgeChange } from "@xyflow/react";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { equals, map } from "ramda";
import type { StoreApi } from "zustand";

import type { Connector, InputWorkflowEventInput } from "@/graphql.ts";
import { saveWorkflowEventMutation } from "@/modules/workflow/graphql/queries.ts";
import type { WorkflowEditorStore } from "@/modules/workflow/stores/workflow-editor-store-types.ts";
import { validateAndFixConnections } from "@/modules/workflow/utils/connections.ts";
import { connectorToEdge } from "@/modules/workflow/utils/generateWorkflow.ts";

export const debouncedSave = AwesomeDebouncePromise(save, 300);

export async function save(workflow: InputWorkflowEventInput, set: StoreApi<WorkflowEditorStore>["setState"]) {
  const workflowPayload = validateAndFixConnections(workflow) as InputWorkflowEventInput;
  if (!equals(workflowPayload, workflow)) {
    // write back the updated state to the store
    const edges = map(
      (connector) => addEdge(connectorToEdge(connector as Connector), [])[0],
      workflowPayload.config.connectors,
    );
    const addEdgeChanges: EdgeChange[] = map((item) => ({ type: "add", item }) satisfies EdgeAddChange, edges);
    set({ edges: applyEdgeChanges(addEdgeChanges, []) });
  }

  // save
  const { error } = await saveWorkflowEventMutation({ workflow: workflowPayload });
  set({ isSavingWorkflow: false });

  if (error) {
    throw error;
  }
}
